<template>
  <transition name="fade">
    <signin v-if="isLoginOpen" @close="onCloseSignin" @signup="isLoginOpen = false;isSignupOpen = true"/>
  </transition>

  <transition name="fade">
    <TMmodal v-show="TMOpen" :isOpen="TMOpen" :type="'header'" @close="onCloseTM"/>
  </transition>

  <transition name="fade">
    <join v-if="isSignupOpen" @close="onCloseSignup"/>
  </transition>

  <transition name="fade">
    <join-complete v-if="isSignupCompleteOpen" @close="isSignupCompleteOpen = false;isLoginOpen = true"/>
  </transition>

  <transition name="fade">
    <new-message v-if="isUnReadMessage" />
  </transition>
  <header id="mainheader">
    <div class="mega-header-inner">
      <router-link class="mega-header-logo" to="/" aria-label="메가 홈"><img src="@/assets/img/mega-login-logo.png" alt="메가 CASINO" /></router-link>
      <nav ref="navigation" aria-label="주 메뉴" @keydown.esc.prevent.stop="closeNavMenus($event)" @click="onNavSelect">
        <details class="mega-nav-menu" name="mega-navigation" @pointerenter="openHoverMenu" @pointerleave="closeHoverMenu" @focusout="closeHoverMenu">
          <summary>게임실행 <img src="@/assets_mobile/img/icon_arrowBottom.svg" alt="" width="8" height="5" /></summary>
          <div class="mega-nav-dropdown">
            <template v-for="group in ['casino', 'slot', 'sport', 'minigame']" :key="group">
              <button v-for="item in navigationGames[group] || []" :key="group + item.code" type="button" @click="group === 'slot' ? slotOpen('isSlot', 'slot', item.codeName, item.code) : onCasinoSelectGame(item.groupCode, item.code)">{{ $i18n.locale === 'ko' ? item.codeName : (item.codeNameEN || item.codeName) }}</button>
            </template>
          </div>
        </details>
        <details class="mega-nav-menu" name="mega-navigation" @pointerenter="openHoverMenu" @pointerleave="closeHoverMenu" @focusout="closeHoverMenu">
          <summary>충전/환전 <img src="@/assets_mobile/img/icon_arrowBottom.svg" alt="" width="8" height="5" /></summary>
          <div class="mega-nav-dropdown mega-money-menu">
            <button type="button" @click="goPageByName('charge')">충전하기</button>
            <button type="button" @click="goPageByName('exchange')">환전하기</button>
            <button type="button" @click="goPageByName('chargeList')">충/환전내역</button>
            <button type="button" @click="goPageByName('coincharge')">테더입금</button>
            <button type="button" @click="goPageByName('coinexchange')">테더출금</button>
          </div>
        </details>
        <button type="button" @click="goPageByName('bettingList')">베팅이력</button>
        <button type="button" @click="goPageByName('noticeList')">공지사항</button>
        <button type="button" @click="goPageByName('qnaList')">고객센터</button>
        <a v-if="userData && userData.isPartnerMember === 'Y'" href="/UZ2" target="_blank" rel="noopener">파트너</a>
      </nav>
      <div class="mega-account" v-if="userData">
        <p><strong>{{ userData.memNick }}</strong>님 <span>쪽지 : {{ unReadMessageCount || 0 }}</span> <span>보유금액 : <b>{{ thousand(userData.cashAmt || 0) }}</b></span></p>
        <div><button type="button" @click="goPageByName('info')">정보수정</button><button type="button" class="mega-logout" @click="signOut">로그아웃</button></div>
      </div>
      <div class="mega-account" v-else><div><button type="button" @click="onClickLogin">로그인</button><button type="button" @click="onClickSignup">회원가입</button></div></div>
    </div>
  </header>
</template>

<script>

import { mapState } from 'vuex'
import Join from '@/components/member/Join'
import JoinComplete from '@/components/member/JoinComplete'
import Signin from '@/components/member/Signin'
import TMmodal from '@/components/common/TotalMoney'
import { TRIPLE_GAME_LIST } from '@/libs/constants'
import { orderSlotProviders } from '@/libs/utils'
import NewMessage from '@/components/member/Message.vue'

export default {
  name: 'Header',
  components: {
    NewMessage,
    Signin,
    JoinComplete,
    Join,
    TMmodal
  },
  data () {
    return {
      menuList: [],
      TMOpen: false,
      isLoginOpen: false,
      isSignupOpen: false,
      isSignupCompleteOpen: false,
      showMenu: false,
      showMenuMoney: false,
      showMenuLang: false,
      isAlertOpen: false,
      isGameOpen: false,
      isHgameOpen: false,
      isSlotOpen: false,
      isSportsOpen: false,
      isMiniOpen: false,
      isCashOpen: false,
      tripleGameList: TRIPLE_GAME_LIST,
      nside: true
    }
  },
  watch: {
    $route: {
      handler (current) {
        this.gnbReset()
      }
    }
  },
  props: ['selectedMenu'],
  created () {
    this.setMenu()
    this.getHeadMsgList()
  },
  computed: {
    ...mapState([
      'userData',
      'coinAmt',
      'commonCodeByOrder',
      'gameCount',
      'unReadMessageCount',
      'siteOption'
    ]),
    navigationGames () {
      const groups = this.commonCodeByOrder || {}
      return { ...groups, slot: orderSlotProviders(groups.slot || []) }
    },
    isUnReadMessage () {
      return this.unReadMessageCount && this.unReadMessageCount && this.unReadMessageCount !== '0' && this.$route.name.indexOf('message') === -1 && this.$route.name.indexOf('msg') === -1
    }
  },
  methods: {
    openHoverMenu (event) {
      if (event.pointerType !== 'mouse') return
      this.closeNavMenus()
      event.currentTarget.open = true
    },
    closeHoverMenu (event) {
      const menu = event.currentTarget
      if (event.type === 'pointerleave' && (event.pointerType !== 'mouse' || menu.contains(document.activeElement))) return
      if (event.type === 'focusout' && menu.contains(event.relatedTarget)) return
      menu.open = false
    },
    closeNavMenus (event) {
      const menus = this.$refs.navigation?.querySelectorAll('details[open]') || []
      for (const menu of menus) {
        menu.open = false
        if (event?.type === 'keydown') menu.querySelector('summary').focus()
      }
    },
    onNavSelect (event) {
      if (event.target.closest('.mega-nav-dropdown button')) this.closeNavMenus()
    },
    slotOpen (event, groupCode, codeName, code) {
      this.emitter.emit(event, { groupCode, codeName, code })
    },
    gnbReset () {
      this.closeNavMenus()
      this.isGameOpen = false
      this.isHgameOpen = false
      this.isSlotOpen = false
      this.isSportsOpen = false
      this.isMiniOpen = false
      this.isCashOpen = false
      this.showMenu = false
      this.showMenuLang = false
    },
    gnbMenuOpen (type) {
      this.gnbReset()
      if (type === 'game') {
        this.isGameOpen = true
      } else if (type === 'hgame') {
        this.isHgameOpen = true
      } else if (type === 'slot') {
        this.isSlotOpen = true
      } else if (type === 'cash') {
        this.isCashOpen = true
      } else if (type === 'mypage') {
        this.showMenu = true
      } else if (type === 'lang') {
        this.showMenuLang = true
      } else if (type === 'sport') {
        this.isSportsOpen = true
      } else if (type === 'minigame') {
        this.isMiniOpen = true
      }
    },
    getHeadMsgList () {
      // getHeadMsg({}).then(response => {
      //   console.log(response)
      // })
    },
    setMenu () {
      const list = this.$router.getRoutes()
      for (let i = 0, iLen = list.length; i < iLen; i++) {
        const item = list[i]
        if (item.meta && item.meta.gnb) {
          item.isSubOpen = false
          this.menuList.push(item)
        }
      }
    },
    onClickGame (code, name) {
      this.gnbReset()
      if (code) {
        // minigame

        if (code === 'mg') {
          this.$router.push({ name: name })
        } else {
          this.onSelectGame(code)
        }
      } else {
        this.onCheck('준비 중입니다.')
      }
    },
    onClickGnb (item) {
      const name = item.name
      const meta = item.meta
      if (meta.game) {
        this.onSelectGame(meta.gameCode)
      } else {
        this.$router.push({ name: name })
      }
    },
    async onClickTM () {
      const confirmMessage = '통합머니 전환을 진행하시겠습니까?'
      const confirmResult = await this.onConfirm(confirmMessage)
      if (confirmResult) {
        this.TMOpen = true
      }
    },
    onCloseTM () {
      this.TMOpen = false
    },
    onClickLogin () {
      this.isLoginOpen = true
      this.isSignupOpen = false
    },
    onClickSignup () {
      this.isLoginOpen = false
      this.isSignupOpen = true
    },
    onCloseSignin (value) {
      this.isLoginOpen = false
      if (value === 'join') {
        this.isSignupOpen = true
      }
      if (value === 'signin') {
        // location.reload()
      }
    },
    onCloseSignup (status) {
      this.isSignupOpen = false
      if (status) {
        this.isSignupCompleteOpen = true
      }
    }
  }
}
</script>

<style scoped>
#mainheader { position: relative; z-index: 100; background: #171716; color: #ccc; min-height: 68px; }
.mega-header-inner { width: min(1000px, calc(100% - 32px)); margin: auto; min-height: 68px; display: flex; align-items: center; gap: 34px; }
.mega-header-logo { display: block; flex-shrink: 0; width: 105px; height: 66px; }
.mega-header-logo img { width: 100%; height: 100%; object-fit: contain; }
nav { display: flex; align-items: center; gap: 4px; flex: 1; white-space: nowrap; }
nav button, nav a, summary { border: 0; padding: 8px 0; background: none; color: #d2d2d2; font: inherit; font-size: 11px; cursor: pointer; }
nav > button, nav > a, summary { min-height: 68px; padding: 0 12px; box-sizing: border-box; align-content: center; }
nav > button:hover, nav > a:hover, summary:hover, .mega-nav-menu[open] > summary { color: #aeefdd; background: linear-gradient(180deg, transparent 38%, #336f605c 75%, #70b29b80); }
.mega-nav-menu { position: relative; }
summary { display: flex; align-items: center; gap: 5px; list-style: none; line-height: 1.4; }
summary::-webkit-details-marker { display: none; }
summary img { width: 8px; height: 5px; }
.mega-nav-dropdown { position: absolute; top: 100%; left: 50%; transform: translateX(-50%); padding: 0; display: flex; flex-direction: column; width: 168px; max-height: min(430px, calc(100dvh - 100px)); overflow-y: auto; overscroll-behavior: contain; background: linear-gradient(180deg, #60988bed, #477f72fa); border: 0; border-radius: 0 0 10px 10px; box-shadow: 0 8px 20px #0004; scrollbar-width: thin; scrollbar-color: #a1d0bd #4c8175; }
.mega-nav-dropdown button { flex-shrink: 0; min-height: 32px; padding: 8px 10px; color: #edf8f3; font-size: 11px; font-weight: 600; text-align: center; white-space: normal; line-height: 1.4; transition: background .16s ease, color .16s ease; }
.mega-nav-dropdown button:hover, .mega-nav-dropdown button:focus-visible { color: #fff; background: linear-gradient(90deg, #9fe9cb40, #335f5233); }
.mega-nav-dropdown button:focus-visible { outline-offset: -3px; }
.mega-money-menu { width: 140px; }
.mega-account { margin-left: auto; min-width: 270px; text-align: right; font-size: 10px; }
.mega-account p { display: flex; align-items: center; justify-content: flex-end; flex-wrap: wrap; gap: 5px; line-height: 1.4; }
.mega-account b { color: #97e2d4; }
.mega-account > div { display: flex; justify-content: flex-end; gap: 6px; margin-top: 6px; }
.mega-account button { border: 0; border-radius: 15px; padding: 6px 15px; background: #aab9f6; color: #24203b; font-size: 10px; cursor: pointer; }
.mega-account .mega-logout { background: #c294ef; }
button:focus-visible, a:focus-visible, summary:focus-visible { outline: 2px solid #a5f5df; outline-offset: 3px; }
@media (max-width: 1000px) {
  .mega-header-inner { gap: 0 20px; flex-wrap: wrap; }
  nav { order: 3; width: 100%; justify-content: center; gap: 4px; }
  nav > button, nav > a, summary { min-height: 44px; }
  .mega-account { flex: 1; min-width: 0; }
}
@media (max-width: 600px) {
  .mega-header-inner { width: calc(100% - 24px); gap: 10px; }
  nav { gap: 0; flex-wrap: wrap; }
  nav > button, nav > a, summary { padding: 0 8px; }
  .mega-nav-dropdown { left: 0; transform: none; max-width: calc(100vw - 32px); }
}
@media (prefers-reduced-motion: reduce) {
  .mega-nav-dropdown button { transition: none; }
}
</style>
